import { Article } from '@web/newsfeed/types/Article';
import { useNewsfeedBridge } from '@web/newsfeed/NewsfeedBridgeProvider/NewsfeedBridgeProvider';

export function useArticleFooter(article: Article) {
  const newsfeedBridge = useNewsfeedBridge();
  const pageId = article.page.id;

  return {
    pageMembersCount: newsfeedBridge.getPageMembersCount(pageId),
  };
}
